import { createAsyncThunk } from "@reduxjs/toolkit";
import orderService from "../../../api/services/order";

export const getOrders = createAsyncThunk(
  "orders/get-orders",
  async ({ page, limit, sortByStatus }) => {
    return await orderService.getOrders({ page, limit, sortByStatus });
  }
);

export const getOrderById = createAsyncThunk(
  "orders/get-order-by-id",
  async (id) => {
    return await orderService.getOrderById(id);
  }
);

export const createOrder = createAsyncThunk(
  "orders/create-order",
  async (requestData) => {
    return await orderService.createOrder(requestData);
  }
);

export const updateOrderStatus = createAsyncThunk(
  "orders/update-order-status",
  async ({ id, status }) => {
    return await orderService.updateOrderStatus({ id, status });
  }
);

export const deleteOrder = createAsyncThunk(
  "orders/delete-order",
  async (id) => {
    return await orderService.deleteOrder(id);
  }
);
